module.exports = __webpack_public_path__ + "img/house_percentage.66cc611.svg";